import { render, staticRenderFns } from "./AdditionalInvoiceRecipients.vue?vue&type=template&id=c8523e3c&scoped=true"
import script from "./AdditionalInvoiceRecipients.vue?vue&type=script&lang=ts"
export * from "./AdditionalInvoiceRecipients.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalInvoiceRecipients.vue?vue&type=style&index=0&id=c8523e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8523e3c",
  null
  
)

export default component.exports